import { render, staticRenderFns } from "./OrganizationDetails.vue?vue&type=template&id=92c6d722"
import script from "./OrganizationDetails.vue?vue&type=script&lang=ts"
export * from "./OrganizationDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports